import React, {useCallback} from 'react';
import ReactDOM from 'react-dom';
import CategoryContainer from "./CategoryContainer";
import GammeContainer from "./GammeContainer";


function Filter({categories, gammes, selectCategory, selectGamme, hasFilter, resetAll, setShowFilter}) {

    return (<div className="filter-container">
        <GammeContainer selectGamme={selectGamme} gammes={gammes}/>
        <CategoryContainer categories={categories} selectCategory={selectCategory}/>
        <div className="tooltip">
            {hasFilter &&
                <div className="tooltip-item reset">
                    <button onClick={(e) => {
                        e.preventDefault();
                        resetAll()
                    }}>
                        Réinitialiser
                    </button>
                </div>
            }
            <div className="tooltip-item">
                <button onClick={(e) => {
                    e.preventDefault();
                    setShowFilter(false);
                }}>
                    <svg width="16" height="16" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginRight: '6px', position:'relative', top:'2px'}}>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M25.4252 3.34667C26.1916 2.58216 26.1916 1.33935 25.4252 0.574848C24.6606 -0.191616 23.4198 -0.191616 22.6533 0.574848L13.001 10.2272L3.34667 0.574848C2.58216 -0.191616 1.33935 -0.191616 0.574848 0.574848C-0.191616 1.33935 -0.191616 2.58216 0.574848 3.34667L10.2272 13.001L0.574848 22.6533C-0.191616 23.4198 -0.191616 24.6606 0.574848 25.4252C1.33935 26.1916 2.58216 26.1916 3.34667 25.4252L13.001 15.7728L22.6533 25.4252C23.4198 26.1916 24.6606 26.1916 25.4252 25.4252C26.1916 24.6606 26.1916 23.4198 25.4252 22.6533L15.7728 13.001L25.4252 3.34667Z" fill="black"/>
                    </svg>
                    Masquer les filtres
                </button>
            </div>
        </div>

    </div>);
}

export default Filter;
